import * as ngCdkScrolling from '@angular/cdk/scrolling'
import * as ngCore from '@angular/core'

import * as illustration from '../../../../illustrations'
import * as overlay from '../../../../overlay'
import * as checkbox from '../../../checkbox'
import { AtnDsSelectMultipleStore } from '../store'

const SEARCH_ELEMENT_HEIGHT = 44
const CONTAINER_ELEMENT_PADDING = 20
const LIST_ITEM_ELEMENT_HEIGHT = 27
const LIST_ELEMENT_BOTTOM_MARGIN = 10

/**
 * Overlay content for {@link atn-ds-select-multiple}.
 */
@ngCore.Component({
  imports: [
    ngCdkScrolling.ScrollingModule,
    checkbox.Component,
    overlay.attached.Component,
    illustration.emptyState.Component,
  ],
  selector: 'atn-ds-select-multiple-overlay',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link HTMLElement}   */
  public readonly originSg = ngCore.input.required<HTMLElement>({
    alias: 'origin',
  })
  /** @see {@link AtnDsSelectMultipleStore} */
  public readonly store = ngCore.inject(AtnDsSelectMultipleStore)
  /** Current rendered trigger width in pixels. */
  private readonly _originWidthPxSg = ngCore.signal(0)

  /** TODO:  */
  public readonly virtualScrollPxHeightSg = ngCore.computed(
    (
      configOverlay = this.store.configOverlaySg()?.maxHeight,
      filteredCount = this.store.filteredCountSg(),
    ) => {
      // LIST_ITEM_ELEMENT_HEIGHT is for "Select All" element
      const overlayMaxHeight = configOverlay ?? 0

      const calcHeight =
        overlayMaxHeight -
        SEARCH_ELEMENT_HEIGHT -
        LIST_ITEM_ELEMENT_HEIGHT -
        CONTAINER_ELEMENT_PADDING
      const availableHeight =
        calcHeight > LIST_ITEM_ELEMENT_HEIGHT
          ? calcHeight
          : LIST_ITEM_ELEMENT_HEIGHT
      // LIST_ELEMENT_BOTTOM_MARGIN is because last item has no margin bottom
      const calcItemsHeight =
        filteredCount * LIST_ITEM_ELEMENT_HEIGHT - LIST_ELEMENT_BOTTOM_MARGIN
      return availableHeight <= calcItemsHeight
        ? availableHeight
        : calcItemsHeight
    },
  )

  /**
   * Multi-select overlays still support numeric widths only even though the
   * shared config type now also allows `'fit-content'` for single-select.
   *
   * Width falls back to the latest measured trigger width so late layout
   * changes do not leave the overlay stuck with a stale measurement.
   */
  public readonly overlayWidthPxSg = ngCore.computed(() => {
    const configuredWidth = this.store.configOverlaySg().width

    return typeof configuredWidth === 'number'
      ? configuredWidth
      : this._originWidthPxSg()
  })

  constructor() {
    ngCore.effect(onCleanup => {
      const origin = this.originSg()
      const measureOriginWidth = () => {
        this._originWidthPxSg.set(origin.offsetWidth)
      }

      measureOriginWidth()

      const resizeObserver = new ResizeObserver(measureOriginWidth)
      resizeObserver.observe(origin)

      onCleanup(() => {
        resizeObserver.disconnect()
      })
    })
  }
}
